import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MdAssignment,
  MdChecklist,
  MdExpandMore,
  MdExpandLess,
  MdLogout,
  MdPendingActions,
  MdMoney,
  MdCurrencyExchange,
} from "react-icons/md";
import { IoApps } from "react-icons/io5";

const Sidebar = () => {
  const [openAssigned, setOpenAssigned] = useState(false);
  const [openCustom, setOpenCustom] = useState(false);

  const linkStyle = (isActive) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 12px",
    borderRadius: "6px",
    textDecoration: "none",
    color: isActive ? "#fff" : "#333",
    backgroundColor: isActive ? "#2E7D32" : "transparent",
    fontWeight: isActive ? "600" : "normal",
    transition: "0.3s",
  });

  const parentStyle = (isOpen) => ({
    padding: "10px 12px",
    borderRadius: "6px",
    backgroundColor: isOpen ? "#C8E6C9" : "#f5f5f5",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "6px",
    transition: "0.3s",
  });

  return (
    <aside
      style={{
        width: "230px",
        backgroundColor: "#E8F5E9",
        padding: "20px",
        height: "calc(100vh - 80px)",
        borderRight: "3px solid #1b5e2070",
        overflowY: "auto",
      }}
    >
      <h3 style={{ marginBottom: "20px", fontSize: "19px", color: "#1b5e20" }}>
        Energy Club Programme
      </h3>

      <ul style={{ listStyle: "none", padding: 0 }}>

        {/* Assigned Activities */}
        <li>
          <div
            onClick={() => setOpenAssigned(!openAssigned)}
            style={parentStyle(openAssigned)}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MdAssignment size={20} /> Assigned Activities
            </span>
            {openAssigned ? <MdExpandLess /> : <MdExpandMore />}
          </div>

          <div
            style={{
              maxHeight: openAssigned ? "200px" : "0px",
              overflow: "hidden",
              transition: "max-height 0.35s ease",
            }}
          >
            <ul style={{ listStyle: "none", paddingLeft: "15px" }}>
              <li>
                <NavLink to="/" style={({ isActive }) => linkStyle(isActive)}>
                  <MdChecklist size={20} /> Submitted Status
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/ActivityNotSubmitted"
                  style={({ isActive }) => linkStyle(isActive)}
                >
                  <MdPendingActions size={20} /> Not Submitted Status
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        {/* Custom Activities */}
        <li>
          <div
            onClick={() => setOpenCustom(!openCustom)}
            style={parentStyle(openCustom)}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <IoApps size={20} /> Custom Activities
            </span>
            {openCustom ? <MdExpandLess /> : <MdExpandMore />}
          </div>

          <div
            style={{
              maxHeight: openCustom ? "200px" : "0px",
              overflow: "hidden",
              transition: "max-height 0.35s ease",
            }}
          >
            <ul style={{ listStyle: "none", paddingLeft: "15px" }}>
              <li>
                <NavLink
                  to="/CustomProgramMonitor"
                  style={({ isActive }) => linkStyle(isActive)}
                >
                  <MdChecklist size={20} /> Submitted Status
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/CustomProgramNotSubmited"
                  style={({ isActive }) => linkStyle(isActive)}
                >
                  <MdPendingActions size={20} /> Not Submitted Status
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        {/* Fund Utilisation */}
        <li style={{ marginTop: "10px" }}>
          <NavLink
            to="/funds-status"
            style={({ isActive }) => linkStyle(isActive)}
          >
            <MdMoney size={20} /> Fund Utilisation Status
          </NavLink>
        </li>

        {/* Fund Alocation */}
        <li style={{ marginTop: "10px" }}>
          <NavLink
            to="/FundAlocation"
            style={({ isActive }) => linkStyle(isActive)}
          >
            <MdCurrencyExchange size={20} /> Fund Allocation
          </NavLink>
        </li>

        {/* Pending Status */}
        <li>
          <NavLink
            to="/energy-club-pending"
            style={({ isActive }) => linkStyle(isActive)}
          >
            <MdPendingActions size={20} /> Pending Status
          </NavLink>
        </li>

        {/* Logout */}
        <li style={{ marginTop: "15px" }}>
          <NavLink
            to="/logout"
            style={({ isActive }) => linkStyle(isActive)}
          >
            <MdLogout size={20} /> Logout
          </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
